import { useState, useEffect } from 'react';
import '../components/login.css';
import supabase from '../config/supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sessionReady, setSessionReady] = useState(false);

  const navigate = useNavigate();

  // Supabase puts the recovery token in the URL hash when the user
  // clicks the reset link in their email. This effect listens for
  // the session to be established from that token.
  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setSessionReady(true);
      }
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError(null);
    setMessage(null);

    if (!password || !confirmPassword) {
      setError('Please fill in both fields.');
      setIsSubmitting(false);
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setIsSubmitting(false);
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      setIsSubmitting(false);
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError(error.message);
    } else {
      setMessage('✅ Password updated! Redirecting you to login...');
      setTimeout(() => navigate('/login'), 2500);
    }

    setIsSubmitting(false);
  };

  // If the recovery session hasn't kicked in yet, show a holding message
  if (!sessionReady) {
    return (
      <div className="login-container">
        <h2>Reset Password</h2>
        <p style={{ color: '#555', fontSize: '14px' }}>
          Waiting for your reset link to be verified... If nothing happens, please request a new reset link from the login page.
        </p>
        <p
          onClick={() => navigate('/login')}
          className="login-toggle"
        >
          ← Back to Login
        </p>
      </div>
    );
  }

  return (
    <div className="login-container">
      <h2>Set New Password</h2>
      <p style={{ fontSize: '14px', color: '#555', marginBottom: '12px' }}>
        Choose a new password for your account.
      </p>
      <form onSubmit={handleReset}>
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Updating...' : 'Update Password'}
        </button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {message && <p style={{ color: 'green' }}>{message}</p>}
    </div>
  );
}